<!-- <div class="step-pagination text-center">1/4</div> -->

<h1 class="title">Créer le compte candidat</h1>
<h5 class="title-text-muted text-muted fs-16">
  Dans cette première fenêtre, saisissez les données du candidat à créer.
</h5>

<div class="row my-2 align-items-end">
  <div class="col-3">
    <app-custom-drop-down
      cdkFocusInitial
      [parentForm]="form"
      controlName="prefixe"
      class="prefixe-class"
      label="Civilité"
      [options]="civilityOptions"
      [required]="true"
      [simpleDropDown]="true"
    ></app-custom-drop-down>
  </div>
  <div class="col">
    <app-custom-input
      [parentForm]="form"
      controlName="firstName"
      label="Nom"
      [required]="true"
    ></app-custom-input>
  </div>
  <div class="col">
    <app-custom-input
      [parentForm]="form"
      controlName="lastName"
      label="Prénom"
      [required]="true"
    ></app-custom-input>
  </div>
</div>

<div class="row my-3">
  <app-custom-input
    [parentForm]="form"
    controlName="email"
    label="Adresse e-mail du candidat"
    placeholder="ex: jean.dupont@email.com"
    type="email"
    [required]="true"
  ></app-custom-input>
</div>

<!-- <div class="row my-3">
  <app-custom-input
    [parentForm]="form"
    controlName="password"
    label="Mot de passe"
    type="password"
    positionIcon="right"
    [required]="true"
  ></app-custom-input>

  <div
    class="fs-11 my-px-5"
    [ngClass]="{
      required: form.get('password')?.dirty,
      'text-secondary': !form.get('password')?.dirty
    }"
  >
    <span [ngClass]="{ 'text-success': passwordFormField?.match('.{8,}') }">
      Le mot de passe doit contenir au moins 8 caractères
    </span>,
    <span [ngClass]="{ 'text-success': passwordFormField?.match('^(?=.*[A-Z])') }">
      dont une lettre majuscule
    </span>,
    <span [ngClass]="{ 'text-success': passwordFormField?.match('(?=.*[a-z])') }">
      une lettre minuscule
    </span>,
    <span [ngClass]="{ 'text-success': passwordFormField?.match('(.*[0-9].*)') }">
      un chiffre
    </span>,
    <span [ngClass]="{ 'text-success': passwordFormField?.match('(?=.*[!@#$%^&*/])') }">
      et un caractère spécial
    </span>.
  </div>
</div> -->

<!-- <div class="row my-3">
  <app-custom-checkbox
    [formGroup]="form"
    controlName="confirmBtn"
    label="Je confirme avoir lu et accepté les conditions générales d'utilisation"
  ></app-custom-checkbox> 
</div>-->

<div class="row my-3">
  <app-button
    color="primary"
    (handleClick)="nextStep()"
    [disabled]="isFormDisabled"
    text="Créer le compte candidat et continuer"
    class="mx-auto text-center"
    [innerClass]="'p-3 w-100'"
  ></app-button>
</div>
